import { render } from "./PdpRpaModalSearch.vue?vue&type=template&id=d60a5060"
import script from "./PdpRpaModalSearch.vue?vue&type=script&lang=js"
export * from "./PdpRpaModalSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__